import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { ChipComponent } from '../../../../common-shared-module/components/chip/chip.component';
import { SingleFieldComponent } from '../../../../common-shared-module/components/single-field/single-field.component';
import { ToolHelpComponent } from '../../../../common-shared-module/components/tool-help/tool-help.component';
import { SectionLayoutMetadata } from '../../../../common-shared-module/model/dyn-form/form-metadata/layout/section-layout.model';
import { MetadataChange } from '../../../models/metadata-change.model';
import { sectionEditor } from '../../../models/tool-help.model';

@Component({
    selector: 'app-section-metadata-editor',
    templateUrl: './section-metadata-editor.component.html',
    styleUrl: './section-metadata-editor.component.scss',
    standalone: true,
    imports: [
        SingleFieldComponent, ToolHelpComponent, ChipComponent, 

        MatAccordion, MatExpansionModule, MatIconModule, MatDividerModule, 
    ]
})
export class SectionMetadataEditorComponent {

    @Input() item!: SectionLayoutMetadata

    @Output() changeItem: EventEmitter<MetadataChange> = new EventEmitter()


    constructor() { }

    fireChange() {
        let metadataChange = new MetadataChange()
        metadataChange.pushChanged(this.item)
        this.changeItem.emit(metadataChange)
    }

    icon(): string {
        return "view_day"
    }

    helpText(): string {
        return "Yo he visto cosas que no creerias. Atacar naves en llamas, ver rayos C brillar más allá del apuerta de thanhauser, todos esos momentos se perderan como lagrimas en la lluvia. Es hora de morir..."
    }

    updatFieldName(fieldName: string) {
        this.item.fieldName = fieldName;
    }

    fieldNameValidator = sectionEditor.fieldNameValidator

}
